import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cancelReasonPipe'
})
export class CancelReasonPipe implements PipeTransform {

  transform(value: string, 
    args: { countryId: string }): string {
      if(args.countryId == 'ID')
        return `CancelReason.${value}-ID`;
      return `CancelReason.${value}`;
  }

}
